import BaseService from './BaseService';

export class SkipLogin extends BaseService {
  static getLogin(name: string = '') {
    return this.get(name.length > 0 ? `/skip-login-web?nickname=${name}` : '/skip-login-web');
  }
}